import { SVGProps } from "react";

export default function CurveIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 24, width = 24, stroke = "black", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_34690_85540)">
        <path
          d="M0 24V22C5.588 22 10.32 17.65 11.007 11.882C11.813 5.108 17.399 0 24 0V2C18.412 2 13.68 6.35 12.993 12.118C12.186 18.891 6.6 24 0 24Z"
          fill={stroke}
        />
      </g>
      <defs>
        <clipPath id="clip0_34690_85540">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
